<template>
  <drawer-bottom
		show="{{show}}"
		@close="close"
    custom-class="es-filling"
	>
    <view border slot='header'>
      <view class="es-filling__drawer-header">
        <view class="es-filling__drawer-header-title">姓名填写说明</view>
        <view class="es-filling__drawer-header-right" bindtap="close">
          <es-icon class="es-filling__drawer-close" size="24" color="#999999" name="close-filled"></es-icon>
        </view>
      </view>
    </view>
    <view class="es-filling__drawer-content" custom-main='es-content__miniapp_card_header'>
      <view class="tab">
        <view wx:for="{{tabArr}}" key="{{index}}"bind:tap="onChange(item.key)" wx:class="{{activeKey == item.key ? 'tab-item-active' : 'tab-item'}}">
          <view>{{item.title}}</view>
          <view wx:if="{{activeKey == item.key}}" class="tab-line"></view>
        </view>
      </view>
      <view style="height: 58px"></view>
      <scroll-view 
        scroll-y 
        scroll-with-animation 
        scroll-into-view="{{toTitle}}" 
        style="height: calc(100% - 48px)"
        bindscroll="handleScroll"
      >
        <view class="content">
          <view id="block-1">
            <view class="h1 {{__mpx_mode__ === 'web'?'frist-title':''}}">姓名</view>
            <view>乘客姓名需要与所持证件上的名字一致</view>
            <view>若用户所选证件无中文姓名，请直接填写英文姓名</view>
            <view class="h2">护照预订</view>
            <view>中国护照用户请填写证件上的中文姓名，外籍护照请填写证件上的英文姓名。</view>
            <view class="h2">生僻字</view>
            <view>生僻字可用拼音、同音字代替。</view>
            <view class="h2">特殊符号</view>
            <view>姓名中含特殊符号“·”“.”等，请正常输入，若含有“-”“，”可转换成空格输入。</view>
            <view class="h2">港澳台</view>
            <view>香港、澳门、台湾的护照不支持国内航班，预订国内航班时请改用其他证件。</view>
            <view class="h2">姓名较长</view>
            <view>姓名较长需按姓名第一个汉字或英文字符开始按顺序连续输入，其中英文字符输入时不区分大小写。</view>
          </view>
          <view wx:for="{{image_arr}}">
            <view id="block-{{item.number}}">
              <view class="h1">{{item.title}}</view>
              <view class="flex-box" style="height:{{windowHeight}}px;width:{{windowWidth}}px">
                <image class="image" src="{{item.imageSrc}}" />
              </view>
            </view>
          </view>
        </view>
      </scroll-view>
    </view>
    <!-- <view class="es-filling__drawer-footer">
      <es-button bind:click="close" block type="info">我知道了</es-button>
    </view> -->
	</drawer-bottom>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false,
      },
    },
    data: {
      position: 'bottom',
      activeKey: '1',
      toTitle: 'block-1',
      windowWidth: 338,
      image_arr: [
        {
          number: '2',
          title: '老版护照',
          imageSrc:
            'https://pt-starimg.didistatic.com/static/starimg/img/so7TE2H7NP1656403954325.png',
        },
        {
          number: '3',
          title: '新版护照',
          imageSrc:
            'https://pt-starimg.didistatic.com/static/starimg/img/Iwcqdh47rO1656403955321.png',
        },
        {
          number: '4',
          title: '港澳通行证',
          imageSrc:
            'https://pt-starimg.didistatic.com/static/starimg/img/qQZBKhgspk1656403952995.png',
        },
        {
          number: '5',
          title: '台胞证',
          imageSrc:
            'https://pt-starimg.didistatic.com/static/starimg/img/fmBxBXr1lV1656403953087.png',
        },
      ],
      tabArr:[
        {key:'1',title:'姓名'},
        {key:'2',title:'老版护照'},
        {key:'3',title:'新版护照'},
        {key:'4',title:'港澳通行证'},
        {key:'5',title:'台胞证'}
      ],
      heightList:[]
    },
    methods: {
      close() {
        this.activeKey = '1'
        this.toTitle = 'block-1'
        this.$trigger('close')
      },
      onChange(e) {
        this.activeKey = e
        this.toTitle = 'block-' + e
      },
      handleScroll({ detail }) {
        const { scrollTop } = detail
        let findIndex = 0
        this.heightList.find((item, index) => {
          findIndex = index
          return item > scrollTop + 20
        })
        let lastHeight = this.heightList[this.heightList.length - 2]
        if(scrollTop > lastHeight-180){
          findIndex++
        }
        this.activeKey = String(findIndex + 1)
      },
      // 获取当前的元素节点
      getElement (ele, cb) {
        const query = mpx.createSelectorQuery().in(this)
        query
          .select(ele)
          .boundingClientRect(cb).exec()
      },
      // 获取元素高度，
      getElementHeight () {      
        this.heightList = []
        let callback = (rect) => {
          const { height } = rect || {}
          let addHeight = (height || 0) 
          let preHeight = this.heightList.length > 0 ? this.heightList[this.heightList.length-1] : 0
          this.heightList.push(addHeight + preHeight)
        }
        [1,2,3,4,5].forEach(id => {
          this.getElement(`#block-${id}`, callback)
        })
      },

    },
    mounted() {
      mpx.getSystemInfo().then((e) => {
        this.windowWidth = (Math.ceil(Number(e.windowWidth)) || 375) - 24
      })
    },
    computed: {
      windowHeight() {
        return Math.ceil(this.windowWidth / 1.3)
      },
    },
    watch: {
      show(val){
        if(val){
          setTimeout(() => {
            this.getElementHeight()
          }, 500);
        }
      }
    },
  })
</script>

<style lang='stylus' scoped>
  +b('filling')
    /deep/ .drawer-container
      height auto
    /deep/ .drawer-main
      height auto
    +e('drawer-header')
      display flex
      height 60px
      border-bottom 1px solid #eeeeee
      align-items center
    +e('drawer-header-title')
      flex 1
      text-align center
      font-size 16px
      font-weight 500
      margin-left 56px
    +e('drawer-header-right')
      width 56px
      text-align center
    +e('drawer-header-close')
      color #999999
    +e('drawer-content')
      display flex
      flex-direction column
      height calc(80vh - 60px)
      .tab
        display -webkit-box
        overflow-y hidden
        width calc(100% - 16px)
        height 48px
        line-height 45px
        position fixed
        z-index 2
        background #ffffff
        padding-bottom 10px
      .mpx-scroll-view
        flex 1
      .tab-item
      .tab-item-active
        padding 0 14px
        color #333333
        font-size 14px
        min-width 48px
        display flex
        flex-direction column
        align-items center
        font-family PingFangSC-Regular
        &:first-child
          padding-left 0
      .tab-item-active
        font-family PingFangSC-Medium
      .tab-line
        width 44px
        height 3px
        background-color #1473ff
      .content
        overflow-y auto
        color #333333
        font-size 14px
        flex 1
        padding-bottom 80px
        .h1
          font-size 16px
          font-weight bold
          padding 12px 0
        .frist-title
          padding-top 0
        .h2
          font-weight 500
          padding 12px 0
        .flex-box
          display flex
          justify-content center
        .image
          height 100%
          width 100%
    +e('drawer-footer')
      padding 16px 12px
      background-color #ffffff
      /deep/ .es-button
        border-radius 8px
    .set-padding
      padding-bottom 8px
    .word-break
      word-break break-all
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'es-button': '@didi/es-mpx-ui/lib/button',
      'es-popup': '@didi/es-mpx-ui/lib/popup',
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'drawer-bottom': '../drawer-bottom',
    },
  }
</script>
